module.exports = __webpack_public_path__ + "static/media/spotlight-logo.8b6b5de1.png";